module.exports = __webpack_public_path__ + "static/media/2.c6f6d28b.png";